import { combineReducers } from '@reduxjs/toolkit';
import { reducer as studyReducer } from '../slices/study';

const rootReducer = combineReducers({
  study: studyReducer
});

export default rootReducer;
